import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, FileTextIcon, UserIcon, ClockIcon } from 'lucide-react';
export function HcpProblemSlide({
  onNext
}: {
  onNext: () => void;
}) {
  return <div className="flex flex-col h-full px-6 py-10 relative z-10 bg-slate-950 text-slate-300" data-id="element-199">
      <div className="flex-1 flex flex-col max-w-sm mx-auto w-full" data-id="element-200">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="mb-8" data-id="element-201">
          <div className="inline-flex items-center space-x-2 bg-slate-800 text-nhs-lightblue px-3 py-1 rounded-full text-xs font-bold uppercase tracking-wider mb-6 border border-slate-700 shadow-sm" data-id="element-202">
            <span data-id="element-203">Current Workflow</span>
          </div>

          <h1 className="text-3xl font-semibold text-white leading-tight mb-4" data-id="element-204">
            Unstructured referrals slow clinic preparation
          </h1>

          <p className="text-slate-400 leading-relaxed" data-id="element-205">
            Breast clinic referrals often arrive as free-text GP letters and
            patient notes. This means consultants must manually review each
            referral before deciding which clinic is most appropriate.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2
      }} className="flex items-center justify-between mb-8 px-2" data-id="element-206">
          {/* Stack of paper referrals */}
          <div className="relative w-24 h-32" data-id="element-207">
            {[0, 1, 2].map(i => <div key={i} className="absolute inset-0 bg-slate-100 rounded-lg border border-slate-300 shadow-sm flex flex-col p-2" style={{
            transform: `translate(${i * 4}px, ${i * 4}px) rotate(${i * 2}deg)`,
            zIndex: 10 - i
          }} data-id="element-208">
                <div className="flex items-center space-x-1 mb-2" data-id="element-209">
                  <FileTextIcon className="w-3 h-3 text-slate-400" data-id="element-210" />
                  <span className="text-[8px] font-bold text-slate-500 uppercase" data-id="element-211">
                    GP Referral
                  </span>
                </div>
                <div className="w-full h-1 bg-slate-200 rounded-full mb-1" data-id="element-212" />
                <div className="w-3/4 h-1 bg-slate-200 rounded-full mb-1" data-id="element-213" />
                <div className="w-5/6 h-1 bg-slate-200 rounded-full" data-id="element-214" />
              </div>)}
          </div>

          {/* Arrow */}
          <div className="flex-1 flex justify-center" data-id="element-215">
            <ArrowRightIcon className="w-6 h-6 text-slate-600" data-id="element-216" />
          </div>

          {/* Consultant */}
          <div className="w-24 h-32 bg-slate-900 border border-slate-800 rounded-xl flex flex-col items-center justify-center p-3" data-id="element-217">
            <div className="w-12 h-12 bg-slate-800 rounded-full flex items-center justify-center mb-2" data-id="element-218">
              <UserIcon className="w-6 h-6 text-slate-400" data-id="element-219" />
            </div>
            <span className="text-xs text-slate-400 text-center leading-tight" data-id="element-220">
              Manual Review
            </span>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4
      }} className="bg-slate-900 border border-slate-800 rounded-2xl p-5 shadow-lg flex items-start space-x-4" data-id="element-221">
          <div className="bg-slate-800 p-3 rounded-xl text-slate-400" data-id="element-222">
            <ClockIcon className="w-6 h-6" data-id="element-223" />
          </div>
          <div data-id="element-224">
            <p className="text-slate-400 text-sm font-medium mb-1" data-id="element-225">
              Manual review time
            </p>
            <div className="flex items-baseline space-x-2" data-id="element-226">
              <p className="text-white text-2xl font-bold" data-id="element-227">≈ 4 hours</p>
              <span className="text-slate-500 text-sm" data-id="element-228">/ week</span>
            </div>
          </div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.6
    }} className="mt-auto pt-4 max-w-sm mx-auto w-full" data-id="element-229">
        <button onClick={onNext} className="w-full py-4 bg-nhs-blue text-white rounded-xl font-semibold text-lg flex items-center justify-center hover:bg-nhs-darkblue transition-colors shadow-lg shadow-nhs-blue/20 active:scale-[0.98] group" data-id="element-230">
          See patient signals
          <ArrowRightIcon className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-231" />
        </button>
      </motion.div>
    </div>;
}